"use client";
import React, { useState, useEffect } from "react";
import SearchBar from "../component/SearchBar";

export default function SearchBarWrapper({
  initialValue = "",
  rankingType = "overall",
  page = "nhranking",
  className = "search_welcome_main",
}) {
  const [state, setState] = useState({
    userInput: initialValue,
    results: [],
    showSuggestions: false,
  });

  useEffect(() => {
    if (initialValue && initialValue !== state.userInput) {
      setState((prev) => ({ ...prev, userInput: initialValue }));
    }
  }, [initialValue]);

  const handleChange = (val) => {
    setState((prev) => ({ ...prev, userInput: val }));
  };

  const handleSelect = (val) => {
    setState((prev) => ({ ...prev, userInput: val }));
  };

  const handleKeyDown = () => {};

  return (
    <div className={className}>
      <SearchBar
        value={state.userInput}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onSelect={handleSelect}
        showSuggestions={state.showSuggestions}
        results={state.results}
        rankingType={rankingType}
        page={page}
      />
    </div>
  );
}
